import { render, staticRenderFns } from "./Globe.vue?vue&type=template&id=50ac87fd&class=rizwans&"
import script from "./Globe.vue?vue&type=script&lang=js&"
export * from "./Globe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports